import { useEffect, useState } from "react";

import { Search } from "lucide-react";

// components
import { Input } from "@components/input/input";
import { SpinnerSimple } from "@components/spinner-simple/spinner-simple";

// hooks
import { useDebounceCustom } from "@/hooks/debounce/use-debounce";

import { useStoreZustandModelos } from "@/store-zustand/modelos/modelos";

type SearchInputProps = {
  placeholder?: string;
  minLength?: number;
  debounceTime?: number;
  onSearch: (value: string) => void;
  loading?: boolean;
  className?: string;
};

export function SearchInputDashboard({
  placeholder = "Pesquisar...",
  minLength = 3,
  debounceTime = 500,
  onSearch,
  loading = false,
  className = "",
}: SearchInputProps) {
  const [value, setValue] = useState("");
  const { setCurrentPage } = useStoreZustandModelos();

  const debouncedValue = useDebounceCustom(value, debounceTime);

  useEffect(() => {
    if (debouncedValue.length >= minLength || debouncedValue.length === 0) {
      setCurrentPage(1);
      onSearch(debouncedValue);
    }
  }, [debouncedValue, minLength, onSearch, setCurrentPage]);

  return (
    <div className={`relative flex w-full items-center ${className}`}>
      <Search className="absolute left-2.5 h-4 w-4 text-muted-foreground" />

      <Input
        id="search-modelos-dashboard"
        name="q"
        type="search"
        aria-label="Pesquisar por nome de modelo"
        autoComplete="off"
        spellCheck={false}
        value={value}
        placeholder={placeholder}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
        className="w-full rounded-lg bg-background pl-8 pr-8 text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      />

      {loading && (
        <div className="absolute right-2">
          <SpinnerSimple color="muted-foreground" />
        </div>
      )}
    </div>
  );
}
